import { create } from 'zustand';
import { FileType } from 'entities/Files/types';

type FileEditorStore = {
	fileDetails: FileType | null;
};

type FileEditorActions = {
	setFileDetails: (details: FileType) => void;
	reset: () => void;
};

const initialState: FileEditorStore = {
	fileDetails: null,
};

const fileEditorStore = create<FileEditorStore & FileEditorActions>()((set) => ({
	...initialState,
	setFileDetails: (fileDetails) => set(() => ({ fileDetails })),
	reset: () => set(() => ({ ...initialState })),
}));

export const useFileEditorStore = () => fileEditorStore((state) => state);
